import { Method } from 'axios'
import log from '@/calendesk/prototypes/log'
import { sendRequest } from '@/calendesk/api/SendRequest'

export async function captchaFailedHandle (
  method: Method,
  url: string,
  data: Record<string, any> | null = null,
  sendWithAuth = false,
  headers: Record<string, string | number | boolean> = {},
  otherOptions: Record<string, string | number | boolean> = {},
  onUploadProgress?: (progressEvent: ProgressEvent) => void
) {
  // When captcha fails,
  // we can validate user's email and get the stronger captcha code that proofs we deal with a human.
  log.info('Attempting email verification due to CAPTCHA failure.', data)

  let emailToVerify = null

  if (url === 'user/bookings/create/no-auth' ||
    url === 'user/bookings/create/auth') {
    emailToVerify = data?.user?.email
  }

  if (!emailToVerify) {
    // It might not exist, if it's in a different place, put the logic above.
    emailToVerify = data?.email
  }

  if (emailToVerify) {
    return sendRequest(
      method,
      url,
      data,
      sendWithAuth,
      headers,
      otherOptions,
      emailToVerify,
      false,
      null,
      onUploadProgress
    )
  }

  throw new Error('EXTRA_EMAIL_VERIFICATION_FAILED')
}
